<template>
  <div class="component-container card-overflow">
    <v-card class="component-container card-login" :class="{ 'hidden-card': !hiddenSelectCard }">
      <v-form
        v-model="isFormValid"
        @submit.prevent="pushToDashboard"
        class="h-100 d-flex flex-column"
      >
        <v-btn
          variant="plain"
          class="return-btn"
          size="small"
          prepend-icon="mdi-chevron-left"
          :ripple="false"
          @click="logout"
        >
          {{ $t('COMMON.BUTTON.BACK') }}
        </v-btn>
        <v-container class="logo-container">
          <img alt="logo Boomerang" class="logo" src="@/assets/images/boomerang_black_logo.png" />
        </v-container>
        <v-spacer />
        <v-container>
          <p class="subtitle">{{ $t('LOGIN_PAGE.INPUT.SELECT_COLLABORATOR') }}</p>
          <v-select
            id="select-collaborator"
            :items="getCollaboratorList()"
            item-text="title"
            item-value="technical_id"
            :no-data-text="$t('LOGIN_REGISTER.MESSAGE.NO_DATA')"
            v-model="selectedCollaborator"
            :rules="requiredRules"
          >
            <template v-slot:item="{ item, props }">
              <v-list-item :title="item.title" :value="item.value" v-bind="props">
                <v-tooltip
                  v-if="shouldShowTooltip(item, 'select-collaborator')"
                  activator="parent"
                  location="right"
                >
                  {{ item.title }}
                </v-tooltip>
              </v-list-item>
            </template>
          </v-select>
        </v-container>
        <v-spacer />

        <v-container class="d-flex flex-column ga-4">
          <v-btn variant="outlined" :class="getClassButtonPermission" @click="creatCollaborator">
            {{ $t('LOGIN_PAGE.BUTTON.ADD_NEW_COLLABORATOR') }}
            <v-icon icon="mdi-arrow-right" />
          </v-btn>
          <v-btn
            class="boom-button"
            variant="outlined"
            type="submit"
            :disabled="loading || !isFormValid"
            :loading="loading"
          >
            {{ $t('LOGIN_PAGE.BUTTON.SUBMIT_COLLABORATOR') }}
            <v-icon icon="mdi-arrow-right" />
          </v-btn>
        </v-container>
      </v-form>
    </v-card>

    <AddCollaboratorPage
      v-if="loadAddComponent"
      class="component-container card-collaborator"
      :class="{ 'hidden-card-collaborator': showAddComponent }"
      @clicked="onReturnClickChild"
    />
  </div>
</template>

<script>
import AddCollaboratorPage from '@/views/login/restricted/collaborator/AddCollaboratorPage.vue'
import LocalPermissions from '@/constants/localPermissions'
import {
  displayToast,
  handleResponseError,
  shouldShowTooltip
} from '@/components/utils/globalFunction'
import Validator from '@/components/utils/validator'

export default {
  name: 'collaboratorFormPage',
  components: { AddCollaboratorPage },

  data() {
    return {
      loadAddComponent: false,
      showAddComponent: false,
      hiddenSelectCard: true,
      loading: false,
      isFormValid: false,
      selectedCollaborator: '',
      requiredRules: Validator.requiredRules,
      parent: 'loginPage'
    }
  },
  computed: {
    getClassButtonPermission() {
      const connectedUserPermissionList = this.$store.state.auth.userDetail.permissionList
      const connectedUserHasSeveralCollaborators =
        this.$store.state.auth.userDetail.hasSeveralCollaborators
      if (
        !connectedUserPermissionList.some(
          (perm) => perm.title === LocalPermissions.DISTRIBUTOR_ADD_COLLABORATOR.title
        ) ||
        !connectedUserHasSeveralCollaborators
      ) {
        return 'button-hide'
      } else {
        return 'boom-button'
      }
    }
  },
  methods: {
    shouldShowTooltip,
    onReturnClickChild() {
      this.loadAddComponent = false
      this.hiddenSelectCard = true
      setTimeout(() => {
        this.showAddComponent = false
      }, 100)
      setTimeout(() => {
        this.hiddenSelectCard = true
      }, 100)
    },
    creatCollaborator() {
      this.loadAddComponent = true
      this.hiddenSelectCard = false
      setTimeout(() => {
        this.showAddComponent = true
      }, 100)
      setTimeout(() => {
        this.hiddenSelectCard = false
      }, 100)
    },
    getCollaboratorList() {
      const connectedUserDetailCollaborator =
        this.$store.state.auth.userDetail.collaboratorList.map((collaborator) => ({
          technical_id: collaborator.technical_id,
          title: `${collaborator.firstname} ${collaborator.lastname}`
        }))
      return connectedUserDetailCollaborator ? connectedUserDetailCollaborator : []
    },
    async pushToDashboard() {
      this.loading = true
      this.$store.commit('auth/selectedCollaborator', this.selectedCollaborator)
      await this.$router.push({ path: '/dashboard' })
    },
    logout() {
      this.loading = true
      this.$store
        .dispatch('auth/logout')
        .then(
          () => {
            displayToast(this.$t('DISCONNECT.MESSAGE'), 'success')
            this.$emit('messageFromChild', 'logout')
            this.loading = false
          },
          (error) => {
            this.loading = false
            handleResponseError(error)
          }
        )
        .finally(async () => {
          await this.$router.push({ name: 'Login' })
        })
    }
  }
}
</script>
<style scoped>
:deep(.v-select--active-menu .v-field.v-field--active) {
  border-bottom-left-radius: unset;
  border-bottom-right-radius: unset;
  border-bottom: unset;
  border-top-left-radius: 30px !important;
  border-top-right-radius: 30px !important;
}

.return-btn {
  display: flex;
  justify-content: start;
  position: absolute;
  top: 25px;
  left: 25px;
  color: black;
}

.return-btn:hover {
  color: #559a1b;
}

.card-overflow {
  overflow: hidden;
  position: relative;
  background-color: transparent !important;
}

.card-login {
  z-index: 2;
  position: absolute;
}

.card-collaborator {
  left: 100%;
  position: absolute;
}

.hidden-card {
  transform: translateX(100%);
}

.hidden-card-collaborator {
  left: 95%;
  transform: translateX(-100%);
}

:deep(.v-field--error:not(.v-field--disabled) .v-icon) {
  color: unset !important;
}

.subtitle {
  line-height: 20px;
  text-align: left;
  margin-bottom: 2%;
}

.button-hide {
  visibility: hidden;
}

.boom-button {
  width: 100%;
}

.component-container {
  overflow-y: auto;
  border-radius: 20px;
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: auto 5%;
  padding: 5% 7%;
  transition: transform 0.3s;
}

@media (max-width: 499px) {
  .component-container {
    width: 90vw;
    height: calc(100vh - 5%);
  }
}

@media (min-width: 500px) and (max-width: 767px) {
  .component-container {
    width: 70vw;
    height: calc(100vh - 5%);
  }
}

@media (min-width: 768px) and (max-width: 1099px) {
  .component-container {
    width: 40vw;
    height: 80vh;
  }
}

@media (min-width: 1100px) and (max-width: 1599px) {
  .component-container {
    width: 30vw;
    height: 80vh;
  }
}

@media (min-width: 1600px) {
  .component-container {
    width: 20vw;
    height: 80vh;
  }
}

.logo-container {
  margin-right: auto;
  margin-left: auto;
  margin-top: 50px;
  padding: unset;
}

.logo {
  display: flex;
  flex-direction: column;
  margin: auto;
  align-items: center;
  justify-content: center;
  width: 90%;
}
</style>
